import { render } from "./TheFooter.vue?vue&type=template&id=e64a091e&scoped=true"
import script from "./TheFooter.vue?vue&type=script&scoped=true&lang=js"
export * from "./TheFooter.vue?vue&type=script&scoped=true&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=e64a091e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64a091e"]])

export default __exports__